module.exports = __webpack_public_path__ + "img/pic_kehuduan@2x.034025d0.png";